package de.ohhhmhhh.frontend.admin.ui.screens.episode.edit

import de.ohhhmhhh.backend.models.model.article.ArticleEntity

sealed interface EpisodeEditingItem {
    data class ArticleItem(val article: ArticleEntity? = null) : EpisodeEditingItem
    data class HeaderItem(val title: String? = null, val subtitle: String? = null) : EpisodeEditingItem
}